import moment from 'moment'
import { Link } from 'react-router-dom'

const formatDate = value => (value && moment(value).isValid() ? moment(value).format('YYYY-MM-DD') : '—')

const getStartDate = project => {
	const steps = Array.isArray(project?.steps) ? project.steps : []
	const dates = steps
		.map(step => step?.data_rozpoczecia)
		.filter(value => value && moment(value).isValid())
		.map(value => moment(value))
		.sort((a, b) => a.valueOf() - b.valueOf())

	return dates.length ? formatDate(dates[0]) : formatDate(project?.data_rozpoczecia || project?.created)
}

export default function MyProjectsTableRow({ project }) {
	const stepsCount = Array.isArray(project.steps) ? project.steps.length : (project.stepsCount || 0)
	const trainerNames = [...new Set(
		(Array.isArray(project.steps) ? project.steps : []).flatMap(step => (
			Array.isArray(step.trainerNames) && step.trainerNames.length
				? step.trainerNames
				: (Array.isArray(step.pozycje) ? step.pozycje.map(item => item.trainerName) : [])
		)).map(name => `${name || ''}`.trim()).filter(Boolean)
	)]

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-3 px-4 border-b border-gray-200 whitespace-nowrap text-gray-900">
				{getStartDate(project)}
			</td>
			<td className="py-3 px-4 border-b border-gray-200">
				<Link
					to={`/centrumSzkolen/moje-projekty/details/${project._id}`}
					className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
				>
					{project.nazwa || '—'}
				</Link>
			</td>
			<td className="py-3 px-4 border-b border-gray-200 text-gray-900">
				{trainerNames.length ? trainerNames.join(', ') : '—'}
			</td>
			<td className="py-3 px-4 border-b border-gray-200 whitespace-nowrap text-gray-900">
				{stepsCount}
			</td>
		</tr>
	)
}
